"use strict";

Shopify.theme.jsProduct = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsProduct = $.extend(this, Shopify.theme.getSectionData($section)); // function to check if browser is IE

    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./); // Ensure product media libraries are present

    if (!isIE11) {
      window.Shopify.loadFeatures([{
        name: 'model-viewer',
        version: '0.8'
      }, {
        name: 'shopify-xr',
        version: '1.0'
      }, {
        name: 'model-viewer-ui',
        version: '1.0'
      }], Shopify.theme.productMedia.setupMedia);
    }

    var $productGallery = $section.find('.product-gallery__main');
    var $stickyElement = $section.find('.sticky-product-scroll');
    var $recommendedSection = $section.find('.recommended-section');
    var $textImageSlider = $section.find('.text-with-image-slder');
    if ($productGallery) {
      Shopify.theme.jsProduct.enableSlideshow($productGallery);

      if (Shopify.theme.jsProduct.enable_zoom) {
        document.addEventListener('lazyloaded', Shopify.theme.jsProduct.enableZoom($productGallery));
      }

      if (Shopify.theme.jsProduct.enable_product_lightbox) {
        Shopify.theme.jsProduct.enableLightbox($productGallery);
      }
    }

    if ($stickyElement && isScreenSizeLarge() && Shopify.theme.jsProduct.template == 'image-scroll') {
      Shopify.theme.jsProduct.enableStickyScroll($stickyElement, $productGallery);
    }

    if($recommendedSection){
      var tabSlider = $('.recommended-section .rec-prds');
      tabSlider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: Shopify.theme.jsProduct.enable_rec_section_dots,
          arrows: Shopify.theme.jsProduct.enable_rec_section_nav,
          responsive: [
            {
              breakpoint: 901,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  dots: Shopify.theme.jsProduct.enable_mob_rec_section_dots,
                  arrows: Shopify.theme.jsProduct.enable_mob_rec_section_nav
              }
            }
          ]
    
      });
    }

    if($textImageSlider){
      var textImgeSlider = $('.text-with-image-slder .text-image-slides');
      var slides = $('.text-with-image-slder .text-image-slides .text-img-slide').length;
      if(slides > 2)
      textImgeSlider.slick({
          slidesToShow: slides == 3 ? 2.99 : 3,
          slidesToScroll: 1,
          infinite: true,
          dots: Shopify.theme.jsProduct.enable_text_img_slider_dots,
          arrows: Shopify.theme.jsProduct.enable_text_img_slider_nav,
          responsive: [
            {
              breakpoint: 901,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: Shopify.theme.jsProduct.enable_mob_text_img_slider_dots,
                  arrows: Shopify.theme.jsProduct.enable_mob_text_img_slider_nav
              }
            }
          ]
    
      });
      setTimeout(function(){textImgeSlider.slick("refresh");}, 1000);
    }

    $(".product_form_options", $section).each(function () {
      if ($('.select-container').length) {
        new Shopify.OptionSelectors($(this).data("select-id"), {
          product: $(this).data("product"),
          onVariantSelected: selectCallback,
          enableHistoryState: $(this).data("enable-state")
        });
      }
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html(Shopify.translation.notify_form_success);
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function () {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if ($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function success(data) {
              $nf.fadeOut("slow", function () {
                $nf.prev('.message').html(Shopify.translation.notify_form_success);
              });
            },
            error: function error(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    if (Shopify.theme_settings.product_form_style === "swatches") {
      this.enableProductSwatches();
    } else if (Shopify.theme_settings.product_form_style === "dropdown") {
      $('.selector-wrapper select', $section).wrap('<span class="select" data-dropdown-form-style></span>');
      this.findSelectedVariantImage();
    }

    if ($('.masonry--true').length > 0) {
      Shopify.theme.applyMasonry('.thumbnail');
    }

    if ($('[data-bundle-cta]').length > 0 || $('.product-bundle-template').length > 0) {
      Shopify.theme.jsProduct.initBundleDrawer();

      if($('.product-bundle-template').length){
        var bundlePrd = $('[data-bundle-product-page]').data('bundle-product');
        var bundleVar = $('[data-bundle-product-page]').data('bundle-variant-id');
        window.bundleJSON = JSON.parse($('[data-bundle-product-page][data-bundle-script][data-bundle-product="'+bundlePrd+'"][data-bundle-variant-id="'+bundleVar+'"]').html().trim());
        setTimeout(function() {
          $('.shopify-product-form .bundle-drawer-product input:checked').trigger('change');
        },20)
      }
    }

    var $text = $('.product__info-text');
    var $button = $('.product__info-button');
    var maxHeigt;
    if(window.matchMedia( "max-width: 1024px" )) {
      maxHeigt = 80;
    } else {
      maxHeigt = 88;
    }

    if($text.height() <  maxHeigt) {
      $button.addClass('hidden')
      $text.addClass('expanded')
    } else {
      Shopify.contentCreator.textExpanded.init($text,$button);
    }

    // Bold options Modal Popup Function 
    var single_open = false;   
    var productOriginalPrice = $('.purchase-details__buttons').find('.product_current_price').last().text().trim()


    // Product Size Chart Modal Popup Function
    $(document).on('click', '.product__size-chart, [data-product-size-chart]', function () {
      var src = '#size-chart' + $(this).data('product-id');
      console.log(src);
      $.fancybox.open({
        src: src,
        opts: {
          infobar: false,
          toolbar: false,
          touch:false,
          beforeShow: function beforeShow() {
            $('html').addClass('scroll-off');
          },
          beforeClose: function beforeClose() {
            $('html').removeClass('scroll-off');
          }
        }
      });
    });

    if($('[data-variant-upsell]').length && $('[data-variant-upsell] .upsell-prds > div').length > 1){
      $('[data-variant-upsell] .upsell-prds').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: false,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              // infinite: true,
              dots: true,
              swipeToSlide: true,
              arrows: false
            }
          },
        ]
      });
    }

    $('[data-product-upsell] .swatch input').unbind().on('change', function(e){
      Shopify.theme.jsProduct.changeSelectedVariant(e.target);
    });
    if($('[data-product-upsell]').length && $('[data-product-upsell] .upsell-prds > div').length > 1){
      $('[data-product-upsell] .upsell-prds').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: false,
        dots: true,
        arrows: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              // infinite: true,
              dots: true,
              swipeToSlide: true,
              arrows: false
            }
          },
        ]
      });
    }
    if($('[data-product-upsell] .swatch input:checked').length){
      $('[data-product-upsell] .swatch input:checked').trigger('change');
    }
    $(document).on('click','[data-prd-features-slider-toggle]',function(e){
      $(this).toggleClass('active');
      $(this).closest('[data-bndl-prds]').find('.slide-content').slideToggle();
    })
  },
  changeSelectedVariant: function changeSelectedVariant(ele){
    var variantId = $(ele).data('swatch-variant-id');
    var variantAvl = $(ele).data('variant-available');
    var variantSelect = $(ele).closest('form').find('[data-variant-selector]');
    var selVarTitle = $(ele).closest('.swatch').find('.selected-variant');
    var prdImg = $(ele).closest('[data-product-container]').find('[data-variant-images]');
    var swatchImg = prdImg.find('img[alt="'+$(ele).data('image-alt-filter')+'"]')[0];
    var swatchPrice = $(ele).data('swatch-variant-price');
    var swatchcoPrice = $(ele).data('swatch-variant-co-price');
    var atcBtn = $(ele).closest('form').find('button');
    var shipDates = $(ele).closest('[data-product-container]').find('[data-shipping-date]');
    var selShipDate = $(ele).closest('[data-product-container]').find('[data-shipping-date='+variantId+']');
    var productLinks = $(ele).closest('.product-wrap').find('a');
    swatchPrice = Shopify.formatMoney(swatchPrice).split('.00')[0];
    swatchcoPrice = Shopify.formatMoney(swatchcoPrice).split('.00')[0];
    variantSelect.val(variantId).trigger('change'); // change main variant select
    selVarTitle.text($(ele).val()); // change swatch name
    // hide all images except the selected swatch
    if(variantId != '' && productLinks.length){
      $(productLinks).attr('href',$(productLinks).attr('href').split('?')[0]+'?variant='+variantId);
    }
    if(swatchImg!=null){
        prdImg.find('img').hide();
        $(swatchImg).show();
    }


    // add variant pricing on cart btn
    if(atcBtn.data('bundle-cta')){
      atcBtn.html('<span class="text">Build Bundle</span>')
      atcBtn.data('bundle-variant-id',variantId);
    } else{
      if(variantAvl){
        atcBtn.prop('disabled',false).html('<span class="text">Add to cart</span>')
      } else{
        atcBtn.prop('disabled',true).text('SOLD OUT')
      }
    }

    // change est. shipping date metafield value
    console.log($('[data-shipping-date='+variantId+']'));
    if($('[data-shipping-date='+variantId+']') != null){
        shipDates.hide();
        selShipDate.show()
    }

  },
  enableStickyScroll: function enableStickyScroll($stickyElement, $productGallery) {
    var announcementHeight = 0;
    var headerHeight = 0;

    // if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' ) {
    //   announcementHeight = $('#announcement-bar').outerHeight();
    // }

    if (Shopify.theme_settings.header_layout != 'vertical' && Shopify.theme.jsHeader != undefined) {
      if (Shopify.theme.jsHeader.enable_sticky) {
        headerHeight = $('#header').outerHeight();
      }
    }

    var productImages = $productGallery.data('media-count'); //enable if more than 1 image is present

    if (productImages > 1) {
      $stickyElement.stick_in_parent({
        offset_top: announcementHeight + headerHeight + 20
      });
    }
  },
  enableLightbox: function enableLightbox($productGallery) {
    console.log('hello',$productGallery.find('.product-gallery__link'))
    $productGallery.find('.product-gallery__link').fancybox({
      beforeClose: function beforeClose(instance, slide) {
        var $instanceGallery = instance.$trigger.first().parents('.product-gallery__main');
        $instanceGallery.hide();
        setTimeout(function () {
          $instanceGallery.fadeIn(100);
        }, 500);
      },
      afterClose: function afterClose() {
        setTimeout(function () {
          $productGallery.find('.is-selected a').focus();
        }, 500);
      }
    });
  },
  enableZoom: function enableZoom($gallery) {
    $gallery.find('img').each(function (index, image) {
    var $image = $(image);
    var zoomSrc = $image.data('zoom-src');
    if (zoomSrc) {
      $image.wrap('<span class="zoom-container" style="display:block"></span>').css('display', 'block').parent().zoom({
        url: zoomSrc,
        touch: false,
        magnify: 1
      });
    }
  });
  },
  disableSlideshow: function disableSlideshow($section, selector) {
    var $slider;

    if ($section) {
      $slider = $section.find('.flickity-enabled');
    } else {
      $slider = $(selector);
    }

    $slider.flickity('destroy');
  },
  enableSlideshow: function enableSlideshow(selector, settings) {
    // Define variables
    var $productGallery = selector;
    var $thumbnailProductGallery = $productGallery.closest('.product-gallery').find('.product-gallery__thumbnails'); // Adds 'product-gallery__image' class if not present
    if ($productGallery.hasClass('product-images-grid')) {
      return;
    }
    $productGallery.find('.gallery-cell:not(.product-gallery__image)').addClass('product-gallery__image'); // Adds 'product-gallery__thumbnail' class if not present

    $thumbnailProductGallery.find('.gallery-cell:not(.product-gallery__thumbnail)').addClass('product-gallery__thumbnail');
    var $slides = $productGallery.find('.product-gallery__image');
    var $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');
    var thumbnailsEnabled;
    var thumbnailsSliderEnabled;
    var thumbnailsPosition;
    var arrowsEnabled;
    var slideshowSpeed;
    var slideshowTransition;

    if (settings) {
      // If custom settings available, use them otherwise take settings from product templates
      thumbnailsEnabled = settings.thumbnailsEnabled;
      thumbnailsSliderEnabled = settings.thumbnailsSliderEnabled;
      thumbnailsPosition = settings.thumbnailsPosition;
      arrowsEnabled = settings.arrowsEnabled;
      slideshowSpeed = settings.slideshowSpeed;
      slideshowTransition = settings.slideshowTransition;
    } else {
      thumbnailsEnabled = Shopify.theme.jsProduct.thumbnails_enabled;
      thumbnailsSliderEnabled = Shopify.theme.jsProduct.enable_thumbnail_slider;
      thumbnailsPosition = Shopify.theme.jsProduct.thumbnail_position;
      arrowsEnabled = Shopify.theme.jsProduct.thumbnail_arrows;
      slideshowSpeed = Shopify.theme.jsProduct.slideshow_speed;
      slideshowTransition = Shopify.theme.jsProduct.slideshow_transition;
    }

    $productGallery.on('ready.flickity', function () {
      console.log("Enabled Slideshow 2??");
      $slides.each(function (index, slide) {
        //Determine media type
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        var videoID;
        var videoLooping = $('[data-video-loop]').data('video-loop');

        switch (mediaType) {
          case 'external_video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (var i = 0; i < videoPlayers.length; i++) {
                if (videoPlayers[i].id == videoID || videoPlayers[i].media.id == videoID) {
                  videoPlayers[i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[i].keyboard = {
                      focused: false,
                      global: false
                    };
                  }
                }
              }
            }

            break;

          case 'video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (var _i = 0; _i < videoPlayers.length; _i++) {
                if (videoPlayers[_i].id == videoID || videoPlayers[_i].media.id == videoID) {
                  videoPlayers[_i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[_i].keyboard = {
                      focused: true,
                      global: false
                    };
                  }
                }
              }
            }

            break;

          case 'model':
            if ($(slide).hasClass('is-selected')) {
              //When active slide
              if (mediaType == 'model' && isScreenSizeLarge()) {
                $(slide).on('mouseenter', function () {
                  $productGallery.flickity('unbindDrag');
                });
                $(slide).on('mouseleave', function () {
                  $productGallery.flickity('bindDrag');
                });
              }
            }

        } // Detect keyboard 'ENTER' key on slides


        $(slide).keypress(function (event) {
          if (event.which == 13) {
            // Bring focus to media inside selected slide
            $(slide).find('model-viewer, .product-gallery__link, .plyr').focus(); // Run video autoplay logic if featured media is a video

            if (mediaType == 'video' || mediaType == 'external_video') {
              checkForVideos();
            } // Autoplay model if featured media is a model


            if (mediaType == 'model') {
              // If model container has class is-selected then play the model
              autoplayModel();
            }
          }
        });
      });
    });
    $productGallery.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: slideshowSpeed * 1000,
      fade: slideshowTransition === 'fade' ? true : false,
      watchCSS: this.template === 'image-scroll' && !$productGallery.hasClass('js-gallery-modal') ? true : false,
      // Disables Flickity for main product gallery on image-scroll template
      arrowShape: arrowShape
    });
    $productGallery.on('change.flickity', function () {
      $slides.each(function (index, slide) {
        //Determine media type of current slide
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if ($(slide).hasClass('is-selected')) {
          //When active slide
          switch (mediaType) {
            case 'model':
              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */
              if (isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', function () {
                  $productGallery.flickity('unbindDrag');
                }); // On mouseleave event, bind flickity

                $(slide).on('mouseleave', function () {
                  $productGallery.flickity('bindDrag');
                });
              } // Listen for model pause/play events


              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
                $productGallery.flickity('unbindDrag');
              });
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
                $productGallery.flickity('bindDrag');
              });
              break;

            default:
              $productGallery.flickity('bindDrag');
          }
        } else {
          //When inactive slide
          switch (mediaType) {
            case 'external_video':
              //Youtube video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'video':
              //HTML5 video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'model':
              $.each(Shopify.theme.productMedia.models, function (index, model) {
                model.pause();
              });
          }
        }
      }); //Restore 3d model icons

      Shopify.theme.productMedia.showModelIcon($productGallery);
    }); // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile

    var $sliderArrows = $productGallery.find('.flickity-prev-next-button');

    if (($sliderArrows || $thumbnails) && isScreenSizeLarge()) {
      $sliderArrows.on('click', function () {
        $productGallery.on('settle.flickity', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.on('click', function (event) {
        var index = $(event.currentTarget).index();
        $productGallery.flickity('select', index);
        $productGallery.on('settle.flickity', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.keypress(function (event) {
        var index = $(event.currentTarget).index();

        if (event.which == 13) {
          $productGallery.flickity('select', index);
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var pId = $productGallery.data('product-id');
          $productGallery.on('settle.flickity', function (event, index) {
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $productGallery.off('settle.flickity');
          }); // Find out media type of featured media slide

          var mediaType = $selectedSlide.data('media-type') || $selected.find('[data-media-type]').data('media-type'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          return false;
        }
      });
    }

    function checkForVideos() {
      $slides.each(function (index, slide) {
        // Variables
        var $slide = $(slide);
        var mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        var videoID = $slide.find('video').data('plyr-video-id');
        var $iframeVideo = $slide.find('iframe');
        var iframeID = $iframeVideo.attr('id');

        if ($slide.hasClass('is-selected')) {
          if (mediaType == 'video') {
            videoID = $slide.find('video').data('plyr-video-id');

            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType == 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id == iframeID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    setTimeout(function () {
      $productGallery.flickity('resize');
    }, 500);
    $(window).on('load', function () {
      $productGallery.flickity('resize');
    });

    if (thumbnailsEnabled == true && thumbnailsSliderEnabled == true && $slides.length > 1) {
      //If desktop determine which slider we build
      if (isScreenSizeLarge()) {
        if (thumbnailsPosition == 'right-thumbnails' || thumbnailsPosition == 'left-thumbnails') {
          $thumbnailProductGallery.addClass('vertical-slider-enabled');
          var navCellHeight = $thumbnails.height();
          var navHeight = $thumbnailProductGallery.height();
          $productGallery.on('select.flickity', function () {
            // set selected nav cell
            var flkty = $productGallery.data('flickity');

            if (flkty) {
              $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');

              var _$selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected'); // scroll nav


              var scrollY = _$selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
              $thumbnailProductGallery.animate({
                scrollTop: scrollY
              });
            }
          });
        } else {
          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
            asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
            arrowShape: arrowShape
          }); // Ensures Flickity is not collapsed when loaded

          setTimeout(function () {
            $thumbnailProductGallery.flickity('resize');
          }, 500);
          $(window).on('load', function () {
            $thumbnailProductGallery.flickity('resize');
          });
        }
      } else {
        //Otherwise create standard thumbnail slider
        $thumbnailProductGallery.flickity({
          cellAlign: 'center',
          contain: true,
          groupCells: '80%',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
          asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
          arrowShape: arrowShape
        });
      }
    }
  },
  enableProductSwatches: function enableProductSwatches() {
    $('body').on('change', '.swatch :radio', function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      var parentForm = $(this).closest('.product_form form');
      var varId = $(this).data('variant-id');
      // change details on swatch change
      if($('body').hasClass('product-bundle')){
        Shopify.theme.jsProduct.changeBundleDetails(varId);
      }

      if (parentForm.siblings('.notify_form').length) {
        var notifyForm = parentForm.siblings('.notify_form');
      } else {
        var notifyForm = $('.js-notify-form');
      }

      var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
      var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
      var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

      if (option1 && option2 && option3) {
        var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
      } else if (option1 && option2) {
        var notifyMessage = option1 + ' / ' + option2;
      } else {
        var notifyMessage = option1;
      }

      notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage);
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    }); //Swatches linked with selected options

    if ($('.js-product_section').length) {
      var $productForms = $('.js-product_section').find('.product_form');
      $productForms.addClass('is-visible'); //Loop through each product and set the initial option value state

      $productForms.each(function () {
        var JSONData = $(this).data('product');
        var productID = $(this).data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).find('.swatch_options .swatch');
        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    } //Add click event when there is more than one product on the page (eg. Collection in Detail)


    if ($('.js-product_section').length > 1) {
      $('body').on('click', '.swatch-element', function () {
        var swatchValue = $(this).data('value').toString();
        $(this).siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]').prop("checked", true).trigger("change");
        var JSONData = $(this).parents('.product_form').data('product');
        var productID = $(this).parents('.product_form').data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }

    this.findSelectedVariantImage();
  },
  changeBundleDetails: function changeBundleDetails(varId) {
    $('[data-bundle-list-variant]').hide();
    $('[data-bundle-list-variant='+varId+']').show();
  },
  findSelectedVariantImage: function findSelectedVariantImage() {
    $('[data-variant-selector]').on('selectedVariantChanged', function () {
      if ($(this).attr('disabled')) {
        return;
      } else {
        getIndex($(this), $(this).val());
      }
    });

    function getIndex($selector, variantID) {
      var $parentForm = $selector.parents('.product_form');
      var $option = $parentForm.find("select option[value=".concat(variantID, "]"));
      var imageID = $option.attr('data-image-id');

      if (!imageID) {
        // If there is no image, no scrolling occurs
        return false;
      }

      var index = $("[data-image-id=".concat(imageID, "]")).data('index');

      console.log("index: ", index);
      if (Shopify.theme.jsProduct.template === 'image-scroll') {
        Shopify.theme.jsProduct.scrollSelectedImage(index);

      }
    }
  },
  scrollSelectedImage: function scrollSelectedImage(variant) {
    var headerHeight = 0;
    var announceHeight = 0; // Get header height is sticky enabled

    if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
    } // Get announcement height is sticky enabled


    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined'  == true && Shopify.theme_settings.header_layout != 'vertical') {
      announceHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    } // Add values


    var totalHeight = headerHeight + announceHeight;
    Shopify.theme.scrollToTop($("[data-index=\"".concat(variant, "\"]")), totalHeight);
  },
  relatedProducts: function relatedProducts() {
    $('.block__recommended-products .js-related-products-slider .products-slider').each(function (index, value) {
      var $relatedSlider = $(this);
      var slideData = {
        products_per_slide: $relatedSlider.data('products-per-slide'),
        products_available: $relatedSlider.data('products-available'),
        products_limit: $relatedSlider.data('products-limit'),
        initialIndex: 0,
        cellAlign: "left",
        wrapAround: true
      };

      if (slideData.products_available > slideData.products_per_slide && slideData.products_limit > slideData.products_per_slide) {
        slideData.wrapAround = true;
      } else {
        slideData.wrapAround = false;
      }

      if (slideData.products_available < slideData.products_per_slide || slideData.products_limit < slideData.products_per_slide) {
        $relatedSlider.addClass('container is-justify-center');
        $relatedSlider.find('.gallery-cell').addClass('column');
      } else {
        $relatedSlider.flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          wrapAround: slideData.wrapAround,
          pageDots: false,
          contain: true,
          prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
          initialIndex: slideData.initialIndex,
          arrowShape: arrowShape
        });
        setTimeout(function () {
          $relatedSlider.flickity('resize');
        }, 500);
        $(window).on('load', function () {
          $relatedSlider.flickity('resize');
        });
      }
    });
  },
  unload: function unload($section) {
    $('.selector-wrapper select', $section).unwrap();
    this.disableSlideshow($section);
    $('[data-variant-selector]').off();
    document.removeEventListener('lazybeforeunveil', Shopify.theme.jsProduct.enableZoom);
  },
  ajaxLoadProduct: function(event) {
    /* ajaxLoadProduct (Ajax Swatches): function when swatches are pressed to ajax load the product instead of page refresh
    * Need to change:
    *   url
    *   site title
    *   product title
    *   images
    *   price
    *   add to cart
    *   swatch-selection
    *   description
    *   variants
    *   reset embroidery
    */
    if ($(".swatches-ver-0").length > 0) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    var productURL = "https://www.hedleyandbennett.com" + event.target.getAttribute('link-data');
    $.ajax({
      // type:'GET',
      // dataType: "json",
      url: productURL+'?view=json',
      data: {},
      error: function(ish) {
        console.log(ish);
        // window.location.href = productURL;
      },
      success: function(res) {
       
        var jsonInHtml = res.split("</head>")[1];
			  let parseData = JSON.parse(jsonInHtml);
        var product = parseData.product;
        console.log(product);
        var options = product.options;
        var variants = product.variants;
        var variant = product.variants[0];
        var selectOptions = [];
        // console.log($(res).find());
        // if (product.options.length > 1 || product.options[0].values.length > 1) {
        //   // window.location.href = productURL;
        //   return;
        // }
        /* * * * * * * *
        * * * URL  * * *
        * * * * * * * */
        document.title = product.title + " - Hedley & Bennett";
        window.history.pushState({},product.title + " - Hedley & Bennett", '/products/'+product.handle);
        // Push pageview
        ga('send', 'pageview', event.target.getAttribute('link-data'));
        /* * * * * * * *
        * * * Title  * *
        * * * * * * * */
        $('.product_name, .atc-prd-info .h6').text(product.product_title);
        $('[data-product-tags]').addClass('tag-sticker '+product.tags);
        $('[data-product_subtitle]').text(product.product_subtitle);

        // show hide product description blocks
        for(i=1;i<5;i++){
          if(product.product_description['product_description'+i] != null){
            $('[data-product-description-block-'+i+']').text(product.product_description['product_description'+i]);
            $('[data-product-description-block-'+i+']').closest('.text-blk').show();
          } else{
            $('[data-product-description-block-'+i+']').closest('.text-blk').hide();
          }
        }
        

        var avlItemsdesc = product.product_details.also_available_items;
        var apronTypedesc = product.product_details.apron_type_items;

        var descHTML = `
                        <div ${product.product_details.description == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Description: ${product.product_details.description }  </div>
                        </div>
                        <div ${product.product_details.fabric_details == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Fabric Details:  <p> ${product.product_details.fabric_details} </p>  </div>
                        </div>
                        <div ${product.product_details.blade_length == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Blade Length: <p>  ${product.product_details.blade_length} </p></div>
                        </div>
                        <div ${product.product_details.total_length == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Total Length: <p> ${product.product_details.total_length} </p>  </div>
                        </div>
                        <div ${product.product_details.knife_weight == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Weight: <p> ${product.product_details.knife_weight} </p> </div>
                        </div>
                        <div ${product.product_details.knife_hrc == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">HRC: <p> ${product.product_details.knife_hrc} </p> </div>
                        </div>
                        <div ${product.product_details.knife_grind_edge == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Grind & Edge: <p> ${product.product_details.knife_grind_edge} </p> </div>
                        </div>
                        <div ${product.product_details.knife_steel == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Steel: <p> ${product.product_details.knife_steel} </p> </div>
                        </div>
                        <div ${product.product_details.care_instructions == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title">Care instructions: <p> ${product.product_details.care_instructions} </p> </div>
                        </div>
                        <div ${product['meta-size-chart'] == false ? 'style="display:none"' : '' } class="details">
                          <span data-product-size-chart class="det-title" data-product-id="${ product.id }">View Size Guide</span>
                          <div data-size-chart class="size-chart" id="size-chart${ product.id }">
                          </div>
                        </div>
                        <div ${avlItemsdesc == null ? 'style="display:none"' : '' } class="details">
                          <p class="det-title">Also available in: 
                            <span data-avlItemsdesc>
                            </span> 
                          </p>
                        </div>
                        <div ${apronTypedesc == null ? 'style="display:none"' : '' } class="details">
                          <p class="det-title">Apron Type: 
                            <span data-apronTypedesc>
                            </span> 
                          </p>
                        </div>
                        <div ${product.product_details.product_warning == null ? 'style="display:none"' : '' } class="details">
                          <div class="det-title"><span>Warning:</span> <p> ${product.product_details.product_warning} </p> </div>
                        </div>`;
        



        if($('#product-info.pdp_details').length){
          var el = $($('#product-info.pdp_details')[0]);
          var sizeChart = $('[data-size-chart]').length ? $('[data-size-chart]').find('.size-chart-wrap').remove() : '';

          el.find('label.h5').text(`${product.details_acc_title != null ? product.details_acc_title : ''} Details`);
          el.find('.product__info-text').html(descHTML);
          if(avlItemsdesc != null){
            el.find('[data-avlItemsdesc]').html(avlItemsdesc.map((item,i)=>`<a href="${item.url}">${item.title}</a>${i != avlItemsdesc.length - 1 ? ', ': ''}`));
          }
          if(apronTypedesc != null){
            el.find('[data-apronTypedesc]').html(apronTypedesc.map((item,i)=>`<a href="${item.url}">${item.title}</a>${i != apronTypedesc.length - 1 ? ', ': ''}`));
          }
          if(sizeChart != ''){
            el.find('[data-size-chart]').html(sizeChart);
          }

          
        }
        if($('.product__info.pdp_review_highlights') != null){
          if(product.product_details.review_highlights_title != null){
            $('.product__info.pdp_review_highlights').find('[data-rev-hlight-title]').text(product.product_details.review_highlights_title)
          } else{
            $('.product__info.pdp_review_highlights').find('[data-rev-hlight-title]').text('');
          }
        }
        if($('[data-product-features]').length && $('[data-product-features]').find('.feature-title').length && $('[data-review-title]').length){
          var revMsg = JSON.parse($('[data-review-title]').html());
          console.log('revMsg.review_section_title',revMsg.review_section_title);
          $('[data-product-features]').find('.feature-title').text(revMsg.review_section_title+' '+ product.product_title)
        }
        if($('#product-yotpo-reviews h1').length){
          $('#product-yotpo-reviews h1').text(`${product.product_title} Reviews`)
        }
        $($(".breadcrumb").find("li")[3]).html(`
          <span class="breadcrumb-separator">
            <span class="icon " data-icon="slash"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="slash"><path d="M33.5,95.78a2.27,2.27,0,0,1-.71-.13,2,2,0,0,1-1.16-2.58l33-87.55a2,2,0,1,1,3.74,1.41l-33,87.55A2,2,0,0,1,33.5,95.78Z"></path></g></svg>
            </span>
          </span>
          ${product.title}
        `)
        /* * * * * * * *
        * * * Images * *
        * * * * * * * */
        const limitToFour = $('.pdp-4images').length > 0;
        const productImages = limitToFour ? product.images.slice(0,4) : product.images;
        const containerWidth = $(".pdp-slider-heroimg-wrap .slick-list").width();
        $(".pdp-image-wrapper").empty();
        $('.slider-for').slick('unslick');
        $('.slider-nav').slick('unslick');
        $('.pdp-image-wrapper').append(`
        <div class="pdp-slider-heroimg-wrap">
          <div class="slider-for">
          </div>
        </div>
        <div class="pdp-slider-thumbimg-wrap">
          <div class="slider-nav img-slider-nav">
          </div>
        </div>`);
        var sliderImages = $('.pdp-image-wrapper .slider-for');
        var chosenInput = $(`.swatch-container [data-variant-id="${variant.id}"]`);
        var imageAltFilter = $(chosenInput).data('image-alt-filter');
        productImages.map((img, index) => {
          if (img.alt && !img.alt.includes(imageAltFilter)) {
            return "";
          }
          // var image = img.src.slice(6);
          var image;
            if(img.media_type == 'image'){
              image = img.src.slice(6);
            } else{
              image = img.preview_image.src.slice(6)
            }
          var lastImageDot = image.lastIndexOf(".");
  
          var TrackMedia;
          if(img.media_type == 'image'){
            TrackMedia = `          <img
            class="mySlides"
            src="${image.slice(0, lastImageDot)}_1000x${image.slice(lastImageDot)}"
            data-zoom-src="${image.slice(0, lastImageDot)}_2000x${image.slice(lastImageDot)}"
            style="width:100%"
          >`;
          } else{
            TrackMedia = ` <video preload="auto" width="100%" height="100%" autoplay="autoplay" muted playsinline="true" loop="loop">
            <source src="${img.sources[1].url}"
                type="video/mp4">
            Your browser does not support the video tag.
            </video>`;
          }
          var TrackImage = `
          <div
            class="slick-slide slick-current slick-active"
            tabindex="${index == 0 ? 0 : -1}"
            style="
              width: ${containerWidth - 10}px;
              position: relative;
              left: ${index * -1 * (containerWidth - 10)};
              top: 0px;
              z-index: ${index == 0 ? 999 : 998};
            "
            role="tabpanel"
            id="slick-slide1${index}"
            aria-describedby="slick-slide-control1${index}"
            data-slick-index="${index}"
            aria-hidden="${index == 0 ? "false" : "true"}"
          >
            ${TrackMedia}
          </div>
          `;
          $(sliderImages).append(TrackImage);
          return TrackImage;
        });
        var sliderNav = $('.pdp-image-wrapper .img-slider-nav');
        productImages.map((img, index) => {
          if (img.alt && !img.alt.includes(imageAltFilter)) {
            return "";
          }
          // var image = img.src.slice(6);
          var image;
            if(img.media_type == 'image'){
              image = img.src.slice(6);
            } else{
              image = img.preview_image.src.slice(6)
            }
          var lastImageDot = image.lastIndexOf(".");
          var thumbnailImage = `
            <div
              class="slick-slide${index == 0 ? " slick-current" : ""} slick-center"
              data-slick-index="${index}"
              aria-hidden="true"
              tabindex="${index}"
              style="width: 17px;"
            >
              <img
                class="mySlides"
                src="${image.slice(0, lastImageDot)}_200x${image.slice(lastImageDot)}"
                style="width:100%"
              >
            </div>
          `;
          $(sliderNav).append(thumbnailImage);
          return thumbnailImage;
        });

        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: Shopify.theme.jsProduct.slideshow_transition == 'fade' ? true : false,
          asNavFor: '.slider-nav',
          swipeToSlide: false,
          dots: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 901,
              settings: {
                dots: true,
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                // infinite: true,
                dots: true,
                swipeToSlide: true,
                fade: Shopify.theme.jsProduct.slideshow_transition == 'fade' ? true : false,
                arrows: false
              }
            },
          ]
        });

        var slideShow = 1;
        if(productImages.length >= 4){
          slideShow = 4;
        } else if(productImages.length < 2){
          slideShow = productImages.length;
        } else{
          slideShow = productImages.length - 0.01;
        }
        $('.img-slider-nav').slick({
          slidesToShow: slideShow,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          vertical: true,
          verticalSwiping: true,
          dots: true,
          focusOnSelect: true,
          infinite: true,
          swipeToSlide: true,
          dots: false,
          arrows: false
        });
        /* * * * * *
        * Variants *
        * * * * * */
        // Right now, this assumes the variants will be the same in number and name for each swatch.
        
        options[0].values.forEach(opt => {
          var variantOption = variants.find(ele => ele.title == opt);
          // Create select option for form.
          selectOptions.push(`<option value="${variantOption.id}" data-image-id="" data-sku="${variantOption.sku}" data-varaint-${opt}="" id="data-variant-${opt}">${opt}</option>`);
          // console.log('selectOptions',selectOptions);
          // $(`#data-variant-${opt}`).attr("data-sku", variantOption.sku);
          // $(`#data-variant-${opt}`).attr("value", variantOption.id);
          // $(`#data-variant-${opt}`).removeAttr("selected");
          $(`.variant_swatches input[value="${opt}"]`).removeAttr("checked");
          $(`.variant_swatches input[value="${opt}"]`).attr("id", `swatch-0-${opt}-${product.id}`)
          $(`.variant_swatches div[data-value="${opt}"] label`).attr("for", `swatch-0-${opt}-${product.id}`);
          $(`.variant_swatches div[data-value="${opt}"]`).addClass("soldout");
          if (variantOption.inventory_quantity == 0) {
            $(`.variant_swatches div[data-value="${opt}"]`).addClass("soldout");
          } else {
            if (variant.inventory_quantity == 0) { variant = variantOption; }
            $(`.variant_swatches div[data-value="${opt}"]`).removeClass("soldout");
          }
        });
        // Change swatches
        $(`.variant_swatches input[value="${variant.title}"]`).prop("checked", true);
        $(`.selected-variant`).text(variant.title);
        $('.single-option-selector').attr("id", `product-select-${product.id}-option-0`);
        $('.form-variant-select').attr("id", `product-select-${product.id}`);
        $(".product_form").attr("data-product", "")
        // .data('select-id',`product-select-${product.id}`);

        /* NOTES *
        * Variants giving a problem.
        * When you switch colors then switch variants, it removes the select[name="id"] from the form.
        ** END **/

        $('.form-variant-select').html(selectOptions.join(""));
        $('.form-variant-select').attr("name", "id");
        $('.form-variant-select').val(variant.id);
        //Change form option select
        $(`[data-image-id][value=${variant.id}]`).attr("selected", "selected");

        // new Shopify.OptionSelectors($('.js-product_section .product_form').data("select-id"), {
        //   product: $('.js-product_section .product_form').data("product"),
        //   onVariantSelected: selectCallback,
        //   enableHistoryState: $('.js-product_section .product_form').data("enable-state")
        // });

        
        /* * * * * * * *
        * * * Price  * *
        * * * * * * * */
        
        // First, let's see if it is out of stock
        if (variant.inventory_management == 'shopify' && variant.inventory_quantity < 1) {
          $('.cart-area-button').replaceWith(`
            <div id="back-in-stock" class="back-in-stock back-in-stock--single-product cart-area-button">
              <div class="back-in-stock__message">Sorry, selected size is temporarily out of stock</div>
              <a href="#" class="back-in-stock__button button button--primary hidden">Notify me when back in stock</a><a class="back-in-stock__button button button--primary klaviyo-bis-trigger" href="#" style="text-align: center; margin: 0px;">Notify Me</a>
            </div>
          `);

          console.log('variant.id',variant.id);

          var klaviyo = window.klaviyo || [];
          klaviyo.init({
            account:"Myjsxc",
            platform:"shopify"
          });
          klaviyo.enable("backinstock",{
              trigger:{
                  product_page_text:"NOTIFY ME",
                  product_page_class:"back-in-stock__button button button--primary",
                  product_page_text_align:"center",
                  product_page_margin:"0px",
                  alternate_anchor: "back-in-stock",
                  replace_anchor:false
              },
              modal:{
                  headline: "We got you covered",
                  body_content:"Enter your email address to receive an email when this item comes back in stock.",
                  email_field_label:"eg. youareawesome@mail.com",
                  button_label:"NOTIFY ME",
                  subscription_success_label:"You're in! We'll let you know when it's back.",
                  footer_content:'',
                  additional_styles: "@font-face{font-family:Futura;font-weight:400;font-style:oblique;font-display:block;src:url('https://fonts.shopifycdn.com/futura/futura_o4.9747e2e6ed2f11b894984527c927b42234e48815.woff2?h1=aGVkbGV5YW5kYmVubmV0dC5jb20&h2=aGVkbGV5YW5kYmVubmV0dC5vcmc&h3=aGVkbGV5YW5kYmVubmV0dHMuY29t&hmac=d40615830717b81acc4226a730c7a51d010ee72e7e48d9aabd85769e8643667d') format('woff2'),url('https://fonts.shopifycdn.com/futura/futura_o4.d5edc6b1d9a050bbe0beb9093d73b883bf18c6c1.woff?h1=aGVkbGV5YW5kYmVubmV0dC5jb20&h2=aGVkbGV5YW5kYmVubmV0dC5vcmc&h3=aGVkbGV5YW5kYmVubmV0dHMuY29t&hmac=38c62febc8fc12a5c67a8c808a3786505757d57eae1c1ae9b8d99307fd7e31cb') format('woff')}@font-face{font-family:Futura;font-weight:400;font-style:normal;font-display:block;src:url('https://fonts.shopifycdn.com/futura/futura_n4.df36ce3d9db534a4d7947f4aa825495ed740e410.woff2?h1=aGVkbGV5YW5kYmVubmV0dC5jb20&h2=aGVkbGV5YW5kYmVubmV0dC5vcmc&h3=aGVkbGV5YW5kYmVubmV0dHMuY29t&hmac=a8d9d6a0439e886df3928a6df5f277585efe5eeff2fafe4fa6d951d6ee4c417c') format('woff2'),url('https://fonts.shopifycdn.com/futura/futura_n4.6bce24beb4ba1ff4ddeb20f7cd6e2fa513a3d6ec.woff?h1=aGVkbGV5YW5kYmVubmV0dC5jb20&h2=aGVkbGV5YW5kYmVubmV0dC5vcmc&h3=aGVkbGV5YW5kYmVubmV0dHMuY29t&hmac=aa8a86339feb748db22391453c8e165ca398b21f0398246ee2e50fa0a4c33cc1') format('woff')}@font-face{font-family:futura-pt-bold;src:url('https://use.typekit.net/af/053fc9/00000000000000003b9af1e4/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3') format('woff2'),url('https://use.typekit.net/af/053fc9/00000000000000003b9af1e4/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3') format('woff'),url('https://use.typekit.net/af/053fc9/00000000000000003b9af1e4/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3') format('opentype');font-display:auto;font-style:normal;font-weight:700}@font-face{font-family:futura-pt-demi;src:url('https://use.typekit.net/af/c4c302/000000000000000000012192/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3') format('woff2'),url('https://use.typekit.net/af/c4c302/000000000000000000012192/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3') format('woff'),url('https://use.typekit.net/af/c4c302/000000000000000000012192/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3') format('opentype');font-display:auto;font-style:normal;font-weight:600;font-display:swap}.btn{font-family: 'futura-pt-demi';height:40px;background-color: #2D2B29;color: #fff;border-color: #2D2B29;font-weight:600;border-radius:5px;font-size:14px;line-height:14px;width: 292px;letter-spacing:1.1px;display:block;margin:0 auto}.submit-container{margin-top: 30px;padding-top: 25px;border-top: 1px solid #DDDDDD;}.form-group::before{font-family: 'futura-pt-demi';margin-bottom: 4px;line-height: 22px;display: block;}.form-group:nth-child(1) #variant_select:not([style*='display: none'])::before{content: 'Select Size *';font-family: 'futura-pt-demi';margin-bottom: 4px;line-height: 22px;display: block;}.form-group:nth-child(2)::before{content: 'Email *';}.small-print:empty{display:none}.close{font-weight:300;top: 18px;right: 30px;}.input-lg::placeholder{opacity: 0.5;}.modal-title{font-size:20px;font-family: 'futura-pt-bold';padding: 0 32px;border-bottom: 1px solid #DDDDDD;margin: 0 -32px;padding-bottom: 24px;line-height: 26px;}.form-group{margin-bottom: 24px;}p{font-size: 16px;margin: 24px 0;line-height:1.4;}select.input-lg{background:url('https://cdn.shopify.com/s/files/1/0402/9979/0487/files/down-arrow.svg?v=1645446580') no-repeat 89% 50%;width: 170px;-moz-appearance:none;-webkit-appearance:none;appearance:none}.input-lg{font-size:16px;border-radius:5px;line-height:1.5;border-color:#dddddd;height: 40px;padding: 6px 16px;}#klaviyo-bis-modal{max-width:unset!important;width: 100%;height: 100%;margin:auto}#container{border-radius: 0px;margin:100px 20px 0;padding: 24px 32px;width: 462px;left: 50%;transform: translateX(-50%);height: 461px;}@media only screen and (max-width:600px){.modal-title{line-height:26.6px;margin:0 -24px;padding: 0 24px 24px;}#container{width:unset;left:unset;transform:unset;padding:24px}p{margin: 16px 0;}}@media only screen and (max-width:319px){.btn{width:unset}}",
                  drop_background_color:"#000",
                  background_color:"#fff",
                  text_color:"#2c383f",
                  button_text_color:"#2C383F",
                  button_background_color:"#FFE232",
                  close_button_color:"#2C383F",
                  error_background_color:"#fcd6d7",
                  error_text_color:"#E73C3E",
                  success_background_color:"#fff",
                  success_text_color:"#39a227",
                  selected_variant_id: variant.id,
                  unavailable_variants: [
                     {id: variant.id}
                  ]
              }
          });
        }
        else {
var addToCartButtons = `
            <div class="purchase-details has-quantity-box cart-area-button">
              <div class="purchase-details__quantity product-quantity-box quantity-box--box">
                <label class="label is-sr-only" for="quantity">Qty</label>
                <div class="quantity-wrapper field has-addons quantity-style--box ">
                    <div class="control minus-control">
                      <span class="quantity-minus quantity-element button is-inverse" data-update-quantity="minus" disabled="">
                          <span class="icon " data-icon="minus">
                            <svg width="10" height="2" viewBox="0 0 10 2" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.25 0H9.32422V1.17578H5.25H4.07422H0V0H4.07422H5.25Z" fill="#272AA2"></path>
                            </svg>
                          </span>
                      </span>
                    </div>
                    <div class="control quantity-input-control quantity-input-control--fill"> <input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="1" data-line-id=""></div>
                    <div class="control plus-control">
                      <span class="quantity-plus quantity-element button is-inverse" data-update-quantity="plus">
                          <span class="icon " data-icon="plus">
                            <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.58789 0V4.07422H9.66211V5.25H5.58789V9.32422H4.41211V5.25H0.337891V4.07422H4.41211V0H5.58789Z" fill="#272AA2"></path>
                            </svg>
                          </span>
                      </span>
                    </div>
                </div>
              </div>
              <div class="cart-warning"></div>
              <div class="purchase-details__buttons purchase-details__spb--false">
                <button type="button" name="add" class="button ajax-submit action_button button--add-to-cart bold_hidden" data-label="Add to cart" data-add-to-cart-trigger="" data-event-queue-button="0" style="display: none;">
                    <span class="text">Add to cart</span> 
                </button>
                <button type="button" name="add" class="button ajax-submit action_button button--add-to-cart bold_clone" data-label="Add to cart" data-add-to-cart-trigger="" data-event-queue-button="0">
                    <span class="text">Add to cart</span> 
                </button>
              </div>
          </div>
          `;

          var embBtn = `<div ${Shopify.theme.jsProduct.hide_embroidery == false && Shopify.theme.jsProduct.has_embroidery ? 'style="display:block"' : 'style="display:none"' } class="embroidery-btn">
              <a href="#" class="add-embroidery-btn button button--secondary">
                
                CUSTOMIZE IT
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.25 9.41406H10.5859V3.75C10.5859 3.42641 10.3236 3.16406 10 3.16406C9.67641 3.16406 9.41406 3.42641 9.41406 3.75V9.41406H3.75C3.42641 9.41406 3.16406 9.67641 3.16406 10C3.16406 10.3236 3.42641 10.5859 3.75 10.5859H9.41406V16.25C9.41406 16.5736 9.67641 16.8359 10 16.8359C10.3236 16.8359 10.5859 16.5736 10.5859 16.25V10.5859H16.25C16.5736 10.5859 16.8359 10.3236 16.8359 10C16.8359 9.67641 16.5736 9.41406 16.25 9.41406Z" fill="#2C383F"/>
                </svg>
                </a>
            </div>`;
          var stickyATCBtns = `

                  <button type="button" name="add" class="button ajax-submit action_button button--add-to-cart bold_hidden" data-label="Add to cart" data-add-to-cart-trigger="" data-event-queue-button="1" style="display: none;">
                      <span class="text">Add to cart</span> 
                  </button>
                  <button type="button" name="add" class="button ajax-submit action_button button--add-to-cart bold_clone" data-label="Add to cart" data-add-to-cart-trigger="" data-event-queue-button="1">
                      <span class="text">Add to cart</span> 
                  </button>
                  <p ${Shopify.theme.jsProduct.sticky_atc_msg == undefined ? 'style="display:none"' : '""'} class="body3 free-shipping-atc text-center w-100">${Shopify.theme.jsProduct.sticky_atc_msg}</p>
                </div>
                  <p ${Shopify.theme.jsProduct.sticky_atc_msg == undefined ? 'style="display:none"' : '""'} class="mob-ship-atc body3 free-shipping-atc text-center w-100">${Shopify.theme.jsProduct.sticky_atc_msg}</p>
              `;
          
          
          $('.cart-area-button').replaceWith(addToCartButtons);
          $('.sticky-atc-button').replaceWith(stickyATCBtns);
        }

        if(!product.available){
          $('.embroidery-btn').hide();
        } else{
          $('.embroidery-btn').show();
        }
        var price = variant.price;
        $('.product_current_price').text(Shopify.formatMoney(price, $('body').data('money-format')).split('.')[0]);
        
        if($('.product_current_price').parent().find('.com-prd-price') != null && $('.product_current_price').parent().find('.com-prd-price').length){
          $('.product_current_price').parent().find('.com-prd-price').remove();
        }
        if($('.product_current_price').parent().find('.atc-price.was-price') != null && $('.product_current_price').parent().find('.atc-price.was-price').length){
          $('.product_current_price').parent().find('.atc-price.was-price').remove();
        }
        if (variant.compare_at_price) {
          $('.product_current_price').parent().addClass("sale");
          $('.product_current_price').parent().append(`<p class="com-prd-price"><span class="prd-price was-price">${Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')).split('.')[0]}</span></p>`);
        } else {
          $('.product_current_price').parent().removeClass("sale");
        }
        console.log('product.estimated_ship_date',product.estimated_ship_date);
        if(product.estimated_ship_date != null){
          $('.product_section').find('.shopify-product-form').prepend(`<div class="h7 estimated-ship-date"><span class="body2">Est. Ship Date:</span>  ${product.estimated_ship_date}</div>`)
        } else{
          if($('.product_section').find('.shopify-product-form .estimated-ship-date') != null && $('.product_section').find('.shopify-product-form .estimated-ship-date').length){
            $('.product_section').find('.shopify-product-form .estimated-ship-date').remove();
          }
        }

        /* * * * * * * *
        * Add to Cart  *
        * * * * * * * */
        if($('.shopify-product-form').find("#variant-input").length == 0){$('.purchase-details').append(`<input id="variant-input" type="hidden" name="id" value="" />`)}
        if($('.shopify-product-form').find(".add-embroidery-btn").length == 0){$(embBtn).insertBefore( ".purchase-details.has-quantity-box" );}
        $('.atc-prd-info .h6').text(product.product_title);
        $('.atc-prd-info .h8').text(product.product_subtitle);
        $("#variant-input").attr("value", variant.id);
        $('.product_form').attr("id", `product-form-${product.id}`);
        $('.product_form').attr("data-select-id", `product-select-${product.id}`);
        $('.product_form').attr("data-product-id", product.id);
        $(".shopify-product-form").attr("id", `product_form_${product.id}`);
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
        /* * * * * * * * * *
        * Selected Swatch  *
        * * * * * * * * * */
        // $('.product-swatches__swatch').removeClass("current");
        // $(event.target).parent().addClass("current");
        /* * * * * * * *
        * Description  *
        * * * * * * * */
        // $('.product__info-text').html(product.body_html);
        /* * * * * * *
        * Embroidery *
        * * * * * * */


        /* * * * * * *
        * Image swap *
        * * * * * * */
        var location = window.location.href;
        var oldsettings = {
          "url": location+"?view=json",
          "method": "GET",
        }

        $.ajax(oldsettings).done(function (response) {
          var jsonInHtml = response.split("</head>")[1];
          let parseData = JSON.parse(jsonInHtml);
          let imageUrl = parseData.product.apron_mock;
          if(imageUrl){
            $('#previewImageBlock').attr('src',imageUrl);
          }
          else{
            let defaultSrc = 'https:' + $('#previewImageBlock').attr('data-img');
            $('#previewImageBlock').attr('src',defaultSrc);
          }
          
        });
      }
    });
  },
  initBundleDrawer: function(event){

    $('[data-bundle-cta]').click(function(e){
      var bundlePrd = $(this).data('bundle-product');
      var bundleVar = $(this).data('bundle-variant-id');
      window.bundleJSON = JSON.parse($('[data-bundle-script][data-bundle-product="'+bundlePrd+'"][data-bundle-variant-id="'+bundleVar+'"]').html().trim());

      console.log(window.bundleJSON);
      Shopify.theme.jsProduct.buildBundleDrawer(window.bundleJSON);
    });



    // change swatch values
    $(document).on('change','[data-bundle-variants] input', function(e){
      var imageAlt = $(this).data('image-filter');
      var imgDiv = $(this).closest('.bundle-drawer-product').find('[data-bundle-variant-image]');
      var prodId = $(this).data('bundle-product-id');
      var varId = $(this).data('bundle-variant-id');
      var estShip = $(this).data('var-est-ship-date');
      var shipDiv = $(this).closest('.bundle-drawer-product').find('.est-shipping-date');
      var varTtile = $(this).data('bundle-variant-name');
      var prdUrl = $(this).data('bundle-prd-url');
      var varsubtitle = $(this).data('bundle-variant-subtitle');
      var variantDiv = $(this).closest('.bundle-drawer-product').find('[data-selected-bundle-variant]');
      var prodTitleDiv = $(this).closest('.bundle-drawer-product').find('[data-product-title]');
      var prodsubTitleDiv = $(this).closest('.bundle-drawer-product').find('[data-product-subtitle]');
      var prodTagsDiv = $(this).closest('.bundle-drawer-product').find('[data-prod-tags]');
      var isBundlePDPswatch = $(this).closest('[data-bundle-pdp-variants]').length && $(this).data('bundle-coll-swatch') == true;
      
      var selProduct = window.bundleJSON.bundle_products.filter((x) => x.product_id == prodId);
      // console.log('selProduct',selProduct);
      if(selProduct.length){
        var selImg = '';
        if(imageAlt != undefined){
          selImg = selProduct[0].product_images.filter((img) => img.alt == imageAlt);
        } else{ // for coll product swatches for aprons
          selImg = selProduct[0].bundleGroupProducts.filter((prod) => prod.id == varId);
          // console.log('selImg',selImg);
          var prodTags = selImg[0].tags.join(' ');
          prodTitleDiv.text(varTtile);
          if(prdUrl != undefined && prdUrl != null){prodTitleDiv.closest('a').attr('href',prdUrl)}
          if(prodsubTitleDiv != undefined){prodsubTitleDiv.text(varsubtitle)}
          prodTagsDiv.removeAttr('class');
          $(prodTagsDiv[0]).addClass('tag-sticker '+prodTags);
        }
        if(selImg.length){
          imgDiv.attr('src',selImg[0].image);
          imgDiv.attr('data-src',selImg[0].image);
        }
        if(estShip != '' && estShip != 'undefined' && estShip != undefined){
          shipDiv.find('[data-est-ship-date]').text(estShip);
          shipDiv.show();
        } else{
          shipDiv.hide();
        }
        variantDiv.text(varTtile);
        
      }
      if(isBundlePDPswatch){
        Shopify.theme.jsProduct.buildBundlePDPsection($(this).data('bundle-pdp-section'),selProduct[0],$(this).data('bundle-variant-id'));
      }
    })

    // bundle add to cart
    $(document).on('click','[data-bundle-atc]',function(e){
      var $addToCartBtn = $(e.currentTarget);
      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
      $addToCartBtn.find('span:not(.icon):not(.prc):not([data-prc])').removeClass("fadeInDown").addClass('animated zoomOut');
      Shopify.theme.jsProduct.addBundletoCart(window.bundleJSON,e,$addToCartBtn);
    })
  },
  buildBundlePDPsection: function(sectionId,selProduct,prdId){
    // console.log($('#'+sectionId),selProduct);
    var selBundleSection = $('#'+sectionId);
    var selBundleCollPrd = selProduct.bundleGroupProducts.filter((x) => x.id == prdId);
    var detailsHTML= '';
    var sizeChart = '';
    var valPropHTML = '',propHTML = '';
    
    // console.log('sel img',prdId, selBundleCollPrd,selBundleCollPrd[0].image, selBundleSection.find('.bndl-img img'), $(selBundleSection.find('.bndl-img img')).attr('src') ,   $(selBundleSection.find('.bndl-img img')[0]).attr('src'));
    // $($(selBundleSection.find('.bndl-img img'))[0]).attr('src',selBundleCollPrd.image);
    $(selBundleSection).find('.bndl-img img').attr('data-srcset','').attr('srcset','').attr('src',selBundleCollPrd[0].image).attr('alt',selBundleCollPrd[0].product_title);
    $(selBundleSection).find('.bndl-img img').attr('data-src',selBundleCollPrd[0].image);
    $(selBundleSection).find('.bndl-cont a').attr('href', selBundleCollPrd[0].url);
    $(selBundleSection).find('.bndl-cont h5').text(selBundleCollPrd[0].product_title);
    if(selBundleCollPrd[0].product_subtitle != null){
      $(selBundleSection).find('.bndl-cont p.body2').text(selBundleCollPrd[0].product_subtitle);
    }
//     console.log('elBundleCollPrd[0]',selBundleCollPrd[0]);
// console.log('size chart', $(selBundleSection).find('[data-bndle-cnt] [data-product-size-chart]'));
    if($(selBundleSection).find('[data-bndle-cnt] [data-product-size-chart]').length){
      sizeChart = $(selBundleSection).find('[data-bndle-cnt] [data-product-size-chart]').closest('.details').remove();
    } 
    // console.log('sizeChart',sizeChart);
    detailsHTML = ` <div ${selBundleCollPrd[0].fabric_details == null ? 'style="display:none"' : '' } class="details w-fit-content">
                        <div class="det-title h8 ">Fabric Details:  <p class="body2 text-grey-200"> ${selBundleCollPrd[0].fabric_details} </p>  </div>
                      </div>
                      <div ${selBundleCollPrd[0].blade_length == null ? 'style="display:none"' : '' } class="details w-fit-content">
                        <div class="det-title h8">Blade Length: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].blade_length} </p></div>
                      </div>
                      <div ${selBundleCollPrd[0].total_length == null ? 'style="display:none"' : '' }  class="details w-fit-content">
                        <div class="det-title h8">Total Length: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].total_length} </p>  </div>
                      </div>
                      <div ${selBundleCollPrd[0].knife_weight == null ? 'style="display:none"' : '' } class="details w-fit-content">
                        <div class="det-title h8">Weight: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].knife_weight} </p> </div>
                      </div>
                      <div ${selBundleCollPrd[0].knife_hrc == null ? 'style="display:none"' : '' } class="details w-fit-content">
                        <div class="det-title h8">HRC: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].knife_hrc} </p> </div>
                      </div>
                      <div ${selBundleCollPrd[0].knife_grind_edge == null ? 'style="display:none"' : '' } class="details w-fit-content">
                        <div class="det-title h8">Grind & Edge: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].knife_grind_edge} </p> </div>
                      </div>
                      <div ${selBundleCollPrd[0].knife_steel == null ? 'style="display:none"' : '' } class="details w-fit-content">
                        <div class="det-title h8">Steel: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].knife_steel} </p> </div>
                      </div>
                      <div ${selBundleCollPrd[0].care_instructions == null ? 'style="display:none"' : '' } class="details w-fit-content"> 
                        <div class="det-title h8 ">Care instructions: <p class="body2 text-grey-200"> ${selBundleCollPrd[0].care_instructions} </p> </div>
                      </div> ` ;

     $(selBundleCollPrd[0].value_prop_img).each((index,ele) =>{
      propHTML += `<div class="value-prop is-flex value-prop w-25 is-align-center">
                      <img src="${ele[0].src}" alt="{{text}}">
                      <p class="body3">${selBundleCollPrd[0].value_prop_text[index]}</p>
                    </div>`;
    });
      
    valPropHTML = `<div ${selBundleCollPrd[0].value_prop_img == null ? 'style="display:none"' : '' }  class="prd-value-props is-flex is-flex-wrap">
                       ${propHTML}
                      </div>`;
    
    if(propHTML != ''){
      // console.log('if');
      $(selBundleSection).find('[data-bndl-cont] .prd-value-props').remove();
      $(selBundleSection).find('[data-bndl-cont]').prepend(valPropHTML)
    } else{
      // console.log('else');
      $(selBundleSection).find('[data-bndl-cont] .prd-value-props').addClass('d-none');
    }
    $(selBundleSection).find('[data-bndle-cnt]').html(detailsHTML).append(sizeChart[0]);
    
  },
  buildBundleDrawer: function(bundleJSON){
    var bundleContainer = $('[data-bundle-drawer]');
    var headerFooterHeight =  0;
    var bundleHTML = '<div class="bundle-drawer-header position-relative">'+
                        '<h5 class="is-align-center is-flex" data-bundle-title>'+bundleJSON.product_title+
                        '<span class="is-flex" data-dis-tag></span>'+
                        '<span class="bg-white border-rounded close-bundle-drawer is-flex is-justify-center is-align-center">'+
                        '<svg data-close-bundle-drawer width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                          '<path d="M15.0898 13.5781C15.5117 14.0469 15.5117 14.75 15.0898 15.1719C14.6211 15.6406 13.918 15.6406 13.4961 15.1719L7.96484 9.59375L2.38672 15.1719C1.91797 15.6406 1.21484 15.6406 0.792969 15.1719C0.324219 14.75 0.324219 14.0469 0.792969 13.5781L6.37109 8L0.792969 2.42188C0.324219 1.95312 0.324219 1.25 0.792969 0.828125C1.21484 0.359375 1.91797 0.359375 2.33984 0.828125L7.96484 6.45312L13.543 0.875C13.9648 0.40625 14.668 0.40625 15.0898 0.875C15.5586 1.29688 15.5586 2 15.0898 2.46875L9.51172 8L15.0898 13.5781Z" fill="#959B9E"/>'+
                        '</svg>'+
                        '</span>'+
                        '</h5>'+
                        '<a class="is-align-center is-flex link2 text-grey-100 text-underline" href="'+bundleJSON.product_url+'">View Details'+
                          '<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                            '<path d="M7.21875 0.691406L12.0312 5.28516C12.168 5.42188 12.25 5.58594 12.25 5.77734C12.25 5.94141 12.168 6.10547 12.0312 6.24219L7.21875 10.8359C6.97266 11.082 6.53516 11.082 6.28906 10.8086C6.04297 10.5625 6.04297 10.125 6.31641 9.87891L9.95312 6.43359H0.65625C0.273438 6.43359 0 6.13281 0 5.77734C0 5.39453 0.273438 5.12109 0.65625 5.12109H9.95312L6.31641 1.64844C6.04297 1.40234 6.04297 0.964844 6.28906 0.71875C6.53516 0.445312 6.94531 0.445312 7.21875 0.691406Z" fill="#959B9E"/>'+
                          '</svg>'+
                        '</a>'+
                      '</div>'+
                      '<div class="bundle-drawer-body h-100">'+
                        '<p class="select-title text-grey-200 body2">Select Your Products</p>'+
                        '<div data-bundle-drawer-body></div>'+
                      '</div>'+
                      '<div class="bundle-drawer-footer bg-white position-sticky bottom-0 text-center">'+
                        '<button data-bundle-atc class="button button--primary">Add to cart </button>'+
                        '<p class="font-bold body4">Save '+Math.round(bundleJSON.bundle_discount)+'% buying this bundle</p>'+
                      '</div>';

    bundleContainer.html(bundleHTML);

    if(bundleJSON.product_compare_price != '$0'){
      console.log(bundleContainer,bundleContainer.find('[data-bundle-title]'));
      bundleContainer.find('[data-bundle-title] [data-dis-tag]').append('<span class="dis-tag position-relative text-uppercase text-white tk-futura-pt">save '+bundleJSON.product_savings+'</span>');
      bundleContainer.find('[data-bundle-atc]').append('<span class="atc-price">'+bundleJSON.product_price+'</span><span class="atc-price was-price">'+bundleJSON.product_compare_price+'</span>');
    }
    var bundleProductsHTML = '';
    $(bundleJSON.bundle_products).each(function(i,prod){
      var tags = prod.product_tags.join(' ');
      var subTitle = prod.product_subtitle == undefined ? '' : prod.product_subtitle;
      var bundlevarHTML = Shopify.theme.jsProduct.buildBundleSwatches(prod);
      var hasProdAvl = prod.product_tags.filter((x) => x.includes('bundleGroup')).length == 0 && !prod.available ? false : true;
      var soldoutTag = (!hasProdAvl) ? '<p class="label4 text-jalapeno">sold out</p>' : '';
      bundleProductsHTML+= '<div class="is-flex bundle-drawer-product" data-product-available="'+hasProdAvl+'">'+
                              '<div class="bundle-drawer-product-image">'+
                                '<img data-bundle-variant-image class="lazyload" data-src="'+prod.product_images[0].image+'">'+
                              '</div>'+
                              '<div data-bundle-prod-info="'+prod.product_id+'" class="bundle-drawer-product-info">'+
                                '<div data-prod-tags class="tag-sticker '+tags+'"></div>'+
                                '<p data-product-title class="h6">'+prod.product_title+'</p>'+
                                '<p data-product-subtitle class="body3 text-grey-200 product-subtitle" class="body3 text-grey-200">'+subTitle+'</p>'+soldoutTag+bundlevarHTML+
                              '</div>'+
                          '</div>';
      
    });

    bundleContainer.find('[data-bundle-drawer-body]').append(bundleProductsHTML);
    if(bundleContainer.find('[data-product-available="false"]').length){bundleContainer.find('[data-bundle-atc]').prop('disabled', true).text('SOLD OUT')}

   

    bundleContainer.addClass('is-visible');
    bundleContainer.find('.close-bundle-drawer').removeClass('d-none');
    $('[data-modal-overlay]').removeClass('d-none');
    $('body,html').addClass('overflow-hidden');
    headerFooterHeight =  $('.bundle-drawer-header').innerHeight() + $('.bundle-drawer-footer').innerHeight();
    $('.bundle-drawer-body').css('max-height','calc(100% - '+headerFooterHeight+'px)')
    setTimeout(function(){
      $('[data-bundle-variants] input:checked').trigger('change') 
    },200)
   

    $('[data-close-bundle-drawer]').click(function(){
      // console.log('close drawr click');
      $('[data-modal-overlay]').addClass('d-none');
      $('body,html').removeClass('overflow-hidden');
      bundleContainer.removeClass('is-visible');
      bundleContainer.find('.close-bundle-drawer').addClass('d-none');
    })
    
  },
  buildBundleSwatches: function(bundleProd){

    var swatchDiv = '';
    var swatchDivCont = '';
    var ship_date = bundleProd.variants[0].ship_date != undefined ?  '<p class="est-shipping-date body4 text-grey-100">Est. Ship Date: <span data-est-ship-date class="text-grey-200">'+bundleProd.variants[0].ship_date+'</span></p>' : '<p style="display:none" class="est-shipping-date body4 text-grey-100">Est. Ship Date: <span data-est-ship-date class="text-grey-200"></span></p>';
    if(bundleProd.variants.length > 1){
    var isCheckedFlag = false;
      $(bundleProd.variants).each(function(i,variant){
        var ischecked = '';
        if(variant.available && !isCheckedFlag){
          ischecked = 'checked';
          isCheckedFlag = true;
        } else{
          ischecked = '';
        }

        var isdisabled = (!variant.available) ? 'disabled' : '';
        var cursorStyle = !variant.available ? 'style="cursor:not-allowed;opacity:0.6"': '';
        swatchDiv += '<input '+ischecked+' '+isdisabled+' data-bundle-variant-name="'+variant.title+'" data-var-est-ship-date="'+variant.ship_date+'" data-bundle-product-id="'+bundleProd.product_id+'" data-image-filter="'+variant.image_identifier+'" class="d-none" id="bundle-'+bundleProd.product_id+variant.id+'-swatch-'+i+'" name="bundle-'+bundleProd.product_id+'-swatch" type="radio" data-bundle-variant-name="'+variant.title+'" data-bundle-variant-id="'+variant.id+'" data-bundle-variant-available="'+variant.available+'">'+
                      '<label for="bundle-'+bundleProd.product_id+variant.id+'-swatch-'+i+'" data-bundle-variant-name="'+variant.title+'" data-bundle-variant-id="'+variant.id+'" data-bundle-variant-available="'+variant.available+'" '+cursorStyle+'>'+                 
                        '<img '+cursorStyle+' src="'+variant.swatch_url+'">'+
                      '</label>';
      })
      swatchDivCont = '<div class="variant-swatches">'+
                        '<p class="body3">Color: <span data-selected-bundle-variant>'+bundleProd.variants[0].title+'</span></p>'+
                          '<div data-bundle-variants>'+swatchDiv+'</div>'+
                          ship_date+
                      '</div>';
      
      
    } else{
      // console.log(bundleProd.available, bundleProd.product_tags ,bundleProd.product_tags.filter((x) => x.includes('bundleGroup')).length);
      var isCheckedFlag = false;
      if(bundleProd.product_tags.filter((x) => x.includes('bundleGroup')).length ){
        $(bundleProd.bundleGroupProducts).each(function(i,variant){
          var varImg = ''
          if(variant.swatch_image != null){
            varImg = variant.swatch_image[0] != undefined ? variant.swatch_image[0].src : variant.swatch_image.src;
          } else{
            varImg = variant.image;
          }
          // console.log('variant.swatch_image',typeof variant.swatch_image[0]);
          var ischecked = '';
          if(variant.available && !isCheckedFlag){
            ischecked = 'checked';
            isCheckedFlag = true;
          } else{
            ischecked = '';
          }
          var isdisabled = (!variant.available) ? 'disabled' : '';
          // console.log('isdisabled',isdisabled, (!variant.available));
          var cursorStyle = !variant.available ? 'style="cursor:not-allowed;opacity:0.6"': '';
          swatchDiv += '<input '+ischecked+' '+isdisabled+' data-bundle-variant-name="'+variant.product_title+'" data-var-est-ship-date="'+variant.ship_date+'" data-bundle-product-id="'+bundleProd.product_id+'"  class="d-none" id="bundle-'+bundleProd.product_id+variant.id+'-swatch-'+i+'" name="bundle-'+bundleProd.product_id+'-swatch" type="radio" data-bundle-variant-name="'+variant.product_title+'" data-bundle-variant-subtitle="'+variant.product_subtitle+'" data-bundle-variant-id="'+variant.id+'" data-bundle-variant-available="'+variant.available+'">'+
                        '<label for="bundle-'+bundleProd.product_id+variant.id+'-swatch-'+i+'" data-bundle-variant-name="'+variant.product_title+'" data-bundle-variant-id="'+variant.id+'" data-bundle-variant-available="'+variant.available+'" '+cursorStyle+'>'+                 
                          '<img '+cursorStyle+' src="'+varImg+'">'+
                        '</label>';
        })
      } else{

        swatchDiv =   '<input checked class="d-none" id="bundle-'+bundleProd.variants[0].id+'-swatch-'+i+'" name="bundle-'+bundleProd.variants[0].id+'-swatch" type="radio" data-bundle-variant-name="'+bundleProd.variants[0].title+'" data-bundle-variant-id="'+bundleProd.variants[0].id+'" data-bundle-variant-available="'+bundleProd.variants[0].available+'">';
      }
      swatchDivCont = '<div class="variant-swatches">'+
          '<div data-bundle-variants>'+swatchDiv+'</div>'+
          ship_date +
      '</div>';
    }
   $('[data-bundle-variants] input[data-bundle-variant-available="true"]').prop('checked',true) 
    return swatchDivCont;
  },
  addBundletoCart: function(bundleJSON,e,$addToCartBtn){
    Shopify.queue = [];
    var randNo = Math.floor(Math.random() * (1000 - 1 + 1) + 1000);
    var selItems = [];
    var prop = {};
    // var count = 0;

    if($(e.target).closest('.shopify-product-form').length){
      $('.shopify-product-form .bundle-drawer-product input:checked').each(function (i,ele) {
        prop = {
          "_bundle_item": true,
          "_bundle_no": randNo,
          "_product_variant_id": bundleJSON.product_variant_id,
          "_product_handle": bundleJSON.product_handle,
          "_bundle_discount": bundleJSON.bundle_discount,
          "_setitemindex": i
        }
        selItems.push({'quantity':  parseInt($(e.target).closest('.shopify-product-form').find('[name="quantity"]').val()) , 'id': $(this).data('bundle-variant-id'), properties: prop});
      })
      
    } else{
      $('[data-bundle-drawer-body] input:checked').each(function (i,ele) {
        prop = {
            "_bundle_item": true,
            "_bundle_no": randNo,
            "_product_variant_id": bundleJSON.product_variant_id,
            "_product_handle": bundleJSON.product_handle,
            "_bundle_discount": bundleJSON.bundle_discount,
            "_setitemindex": i
          }
          selItems.push({'quantity': 1 , 'id': $(this).data('bundle-variant-id'), properties: prop});
      })
    }
    
    console.log('selItems',selItems);
    Shopify.queue = selItems;
    Shopify.theme.jsProduct.addMultipleProducts($addToCartBtn);

  },
  addMultipleProducts: function addMultipleProducts($addToCartBtn) {
    
    Shopify.moveAlong = function() {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        Shopify.addItem(request.id, request.quantity, request.properties, Shopify.moveAlong);
      }
      else {
        // document.location.href = '/cart';
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.text, .icon, .atc-price').removeClass('zoomOut').addClass('fadeInDown');
        if($('[data-close-bundle-drawer]').length){$('[data-close-bundle-drawer]').trigger('click')}

        Shopify.theme.jsAjaxCart.updateView();
        Shopify.theme.jsAjaxCart.showDrawer();
      }
    };
    Shopify.addItem = function(id, qty, properties, callback) {
      var params = {
        quantity: qty,
        id: id
      };
      if(properties != false){
        params.properties = properties;
      }
      // console.log('params',params)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function(){
          if(typeof callback === 'function'){
            callback();
          }
        },
        error: function(){}
      });
    }
    Shopify.moveAlong();
  }
};


